const KEY = "jb_recently_viewed";
const MAX = 8;

export function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

// Store a compact product snapshot (most-recent first, deduped by id).
export function pushRecentlyViewed(product) {
  if (!product?.id) return;
  const snapshot = {
    id: product.id,
    title: product.title,
    images: product.images || [],
    display_price: product.display_price,
    category: product.category,
    tags: product.tags || [],
    variants: (product.variants || []).map((v) => ({
      price: v.price,
      is_enabled: v.is_enabled,
      options: v.options,
    })),
  };
  try {
    const list = getRecentlyViewed().filter((p) => p.id !== product.id);
    list.unshift(snapshot);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* ignore quota errors */
  }
}
